import { z } from "zod";
import { CommunityAsset } from "./asset.js";
import { CommunityItemStatus, CommunityItemType } from "./enums.js";
export const AdminCommunityQueue = z.enum([
    "healthos_review",
    "company_review",
    "reports",
    "published",
]);
export const AdminCommunityItem = z.object({
    id: z.string().uuid(),
    itemType: CommunityItemType.exclude(["milestone"]),
    // Tightened from z.string(): admin items can only carry a moment or kudos
    // lifecycle status. Milestone items are not surfaced in admin queues (they
    // have no human review lifecycle), which is why itemType already excludes
    // "milestone". The status now mirrors that constraint.
    status: CommunityItemStatus,
    companyId: z.string().uuid(),
    companyName: z.string().nullable(),
    primaryText: z.string(),
    secondaryText: z.string().nullable(),
    actorName: z.string(),
    submittedAt: z.string(),
    reportCount: z.number().int().nonnegative(),
    asset: CommunityAsset.nullable(),
    availableActions: z.array(z.enum(["approve", "reject", "remove", "restore", "resolve_report"])),
});
export const AdminCommunityQueuesResponse = z.object({
    queues: z.array(z.object({
        queue: AdminCommunityQueue,
        label: z.string(),
        count: z.number().int().nonnegative(),
    })),
});
export const AdminCommunityItemsQuery = z.object({
    queue: AdminCommunityQueue.optional(),
    // Tightened from z.string().optional(): the admin filter form should only
    // accept the same lifecycle statuses an item can carry. This is optional
    // (omit to view all statuses) but when present must be a real status.
    status: CommunityItemStatus.optional(),
    itemType: CommunityItemType.exclude(["milestone"]).optional(),
    limit: z.string().optional(),
});
export const AdminCommunityItemsResponse = z.object({
    items: z.array(AdminCommunityItem),
});
export const AdminCommunityActionRequest = z.object({
    reason: z.string().trim().max(200).optional(),
    internalNote: z.string().trim().max(1200).optional(),
});
export const AdminCommunityActionResponse = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=admin.js.map